import React, { useState } from "react";
import NoComments from "./NoComments";
import WriteComment from "../Write Comment/WriteCommentForm";
import RepliesList from "../Replies List/RepliesList";
import WriteReplieComment from "../Write Replie Comment/WriteReplyReviewForm";

import Comment from "./Comment";
import ReportComment from "../Report Comment/ReportComment";
import WriteReplieToAReplie from "../Write Replie To a Replie/WriteReplieToAReplie";

function Comments({
  allComments,
  allCommentUsers,
  userComments,
  setPopUp,
  setInterfaces,
  currentNovel,
}) {
  // get id of comment you want to report in page 1
  const [commentId, setCommentId] = useState();
  const [userId, setUserId] = useState();
  const [reportId, setReportId] = useState();
  // get id of comment you want to reply to in page replies list
  const [replyCommentId, setReplyCommentId] = useState();
  const [replyUserId, setReplyUserId] = useState();
  // get pop up with id on it of whom you want to report (comment)
  const [reportPopup, setReportPopUp] = useState(false);

  // write comment pop up
  const [commentPopup, setCommentPopUp] = useState(false);
  // list of replied comments
  const [repliesPopup, setRepliesPopUp] = useState(false);
  // replie to a comment popup
  const [replieCommentPopup, setReplieCommentPopUp] = useState(false);
  // replie to a  replie comment popup
  const [replie2XCommentPopup, setReplie2XCommentPopUp] = useState(false);
  const localuser = JSON.parse(localStorage.getItem("profile"));
  // give me current comment
  const currentComment = allComments?.comments?.filter(
    (comment) => comment._id === commentId
  );
  const currentReportedComment = allComments?.comments?.filter(
    (comment) => comment._id === reportId
  );
  const currentReplyComment = allComments?.comments?.filter(
    (comment) => comment._id === replyCommentId
  );
  // give me all comments so i can manipulate it
  const commentsList = allComments?.comments?.filter(
    (comment) => comment.Replie_id === "" && comment.ReplieX2_id === ""
  );

  // write review popup
  const handleClick = () => {
    if (localuser) {
      setCommentPopUp(true);
    } else {
      setCommentPopUp(false);
      setInterfaces(
        0,
        setTimeout(() => {
          setPopUp(true);
        }, 10)
      );
    }
  };
  function numbersLogic(num) {
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "G";
    }
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
    }
    if (num >= 10 && num <= 99) {
      return "0" + num;
    }
    if (num <= 9) {
      return "00" + num;
    }
    return num;
  }
  return (
    <div>
      <div className="sm:mt-[100px] mt-[50px] ">
        <div className="px-[15px] md:px-0 font-size text-tertiary text-center sm:text-left uppercase">
          novels discussions ({numbersLogic(commentsList?.length)})
        </div>
        <div className="my-[50px]">
          <div className="bg-primary h-[100px] w-full">
            <div className="mx-[15px] md:mx-0 relative h-[90px]">
              <div
                title="Write A Review Comment"
                onClick={handleClick}
                className="bg-tertiary hover:bg-tertiary/90 duration-500 ease-in-out cursor-pointer flex justify-center items-center h-[63px] max-w-[500px] w-full absolute left-1/2 -translate-x-1/2 bottom-0 translate-y-1/2"
              >
                <div className="flex px-2 gap-x-4 justify-center items-center">
                  <h2 className="line-clamp-1 text-[14px] md:text-[16px] capitalize text-primary font-SoraR">
                    Write a review comment
                  </h2>
                  <Arrow className="flex-none" />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Comments */}
        <div className="mt-[100px] mb-[200px]">
          {commentsList?.map((comment) => {
            return (
              <div key={comment._id}>
                <Comment
                  setReportId={setReportId}
                  allComments={allComments}
                  User_Id={comment.User_id}
                  comment={comment}
                  allCommentUsers={allCommentUsers}
                  currentNovel={currentNovel.novels}
                  setUserId={setUserId}
                  setCommentId={setCommentId}
                  setRepliesPopUp={setRepliesPopUp}
                  setReportPopUp={setReportPopUp}
                  setPopUp={setPopUp}
                  setInterfaces={setInterfaces}
                />
              </div>
            );
          })}
          {allComments?.pending === false &&
            allComments?.comments?.length === 0 && (
              <div>
                <NoComments />
              </div>
            )}
          {(allComments?.pending === true ||
            currentNovel?.pending === true) && (
            <div className="my-[200px]">
              <LoadingComments />
            </div>
          )}
        </div>
      </div>
      <div>
        {/* read replies comments */}
        <RepliesList
          setReportId={setReportId}
          setCommentId={setCommentId}
          setReportPopUp={setReportPopUp}
          setReplyUserId={setReplyUserId}
          allComments={allComments}
          allCommentUsers={allCommentUsers}
          userId={userId}
          currentNovel={currentNovel.novels}
          currentComment={currentComment}
          setReplie2XCommentPopUp={setReplie2XCommentPopUp}
          setPopUp={setPopUp}
          setInterfaces={setInterfaces}
          commentId={commentId}
          setReplieCommentPopUp={setReplieCommentPopUp}
          setRepliesPopUp={setRepliesPopUp}
          repliesPopup={repliesPopup}
          setReplyCommentId={setReplyCommentId}
        />
        {/* write replie comment */}
        <WriteReplieComment
          allCommentUsers={allCommentUsers}
          userId={userId}
          currentNovel={currentNovel.novels}
          currentComment={currentComment}
          commentId={commentId}
          replyCommentId={replyCommentId}
          setReplieCommentPopUp={setReplieCommentPopUp}
          replieCommentPopup={replieCommentPopup}
        />
        {/* write replie to replie comment */}
        <WriteReplieToAReplie
          replyUserId={replyUserId}
          currentReplyComment={currentReplyComment}
          allCommentUsers={allCommentUsers}
          currentNovel={currentNovel.novels}
          replyCommentId={replyCommentId}
          replie2XCommentPopup={replie2XCommentPopup}
          setReplie2XCommentPopUp={setReplie2XCommentPopUp}
        />
        {/* report a comment*/}
        <ReportComment
          allCommentUsers={allCommentUsers}
          currentReportedComment={currentReportedComment}
          userId={userId}
          currentNovel={currentNovel.novels}
          reportPopup={reportPopup}
          setReportPopUp={setReportPopUp}
        />
        {/* write a comment */}
        <WriteComment
          setCommentPopUp={setCommentPopUp}
          commentPopup={commentPopup}
        />
      </div>
    </div>
  );
}

export default Comments;
function LoadingComments() {
  return (
    <div
      className="scale-125 flex w-fit justify-center items-center text-center m-auto "
      role="status"
    >
      <svg
        aria-hidden="true"
        className="w-8 h-8 animate-spin text-gray-600 fill-primary"
        viewBox="0 0 100 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
          fill="currentColor"
        />
        <path
          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
          fill="currentFill"
        />
      </svg>
      <span className="sr-only">Loading...</span>
    </div>
  );
}
function Arrow() {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        style={{
          width: "1em",
          height: "1em",
          verticalAlign: "middle",
          fill: "currentColor",
          overflow: "hidden",
        }}
        className="svg-icon text-primary text-[20px]"
        viewBox="0 0 1024 1024"
        version="1.1"
      >
        <path
          d="M0 524.8l281.6 166.4 582.4-531.2L384 704l384 128 256-832zM384 985.6L512 832l-128-64z"
          fill=""
        />
      </svg>
    </div>
  );
}
